import { convertTEDUrvalToUIUrval } from '../../../../../../../../Components/Urval/Utils/convertTEDUrvalToUIUrval';
import {
  TEDEKBokforderVariantEnum,
  TEDEKBokfverVERKAT_KODEnum,
  TEDInputSelectionCondition,
  TEDKRKundkategoriINTERNEnum,
  TEDKRKundkategoriTypEnum,
  TEDSelectionConditionType,
  TEDSelectionOperator,
} from '../../../../../../../../globalQueryTypes';
import { collectionMap } from '../../../../../../../../Model/ModelContext/ModelContext';
import { IUIUrval } from '../../../../../../../../Types/UrvalTypes';
import { IFormatter } from '../../../../../../../../Utils/Formatters/FormatterTypes';
import { NEWLY_ADDED_ID_PREFIX_FOR_UPDATE } from '../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Const/BusinessDataFormConst';
import { FormUpdateAssociatonType } from '../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import { IValues } from '../../../../../../_StandardRutin/Mutations/ObjectMutations/ObjectUpdateMutationBase';
import { BokforderQuery_node_TEDEKBokforder__Associations_Rader } from '../../../Queries/_QueryTypes/BokforderQuery';
import { UtanordningQuery_node_TEDEKBokforder__Associations_Rader } from '../../../Queries/_QueryTypes/UtanordningQuery';
import { translateBokforderTypeToOmforingsType } from '../../../Utils/BokforderUtils';
import { DefaultBfoVariantEnum } from '../../BokforderContext/BokforderContextManager';
import { ISelectedKundRow } from '../BokforderCreateDialog';
import { IVerRowWithPeriod } from '../Components/BokforderVerificationWizardStep2/BokforderVerificationWizardStep2';
import {
  BokforderVerificationQuery_node_TEDEKBokfver__Associations_Konteringar_All,
  BokforderVerificationQuery_node_TEDEKBokfver__Associations_Konteringar_All__Associations,
} from '../Queries/_QueryTypes/BokforderVerificationQuery';

export enum YesOrNoEnum {
  Yes = 'Ja',
  No = 'Nej',
}

export interface IVerRow {
  Automatkonterat: YesOrNoEnum;
  Debet: string | null;
  id: string;
  Kontostrang: string | null;
  Kontoben: string | null;
  Kredit: string | null;
  Periodiserad: YesOrNoEnum;
  Text: string | null;
  refLopnr: number | null;
  periodFrom?: string;
  periodTo?: string;
  _Associations: BokforderVerificationQuery_node_TEDEKBokfver__Associations_Konteringar_All__Associations | null;
}

export const makeBfoRowsFromVerRows = (
  verRows: IVerRowWithPeriod[],
  bokforderType: TEDEKBokforderVariantEnum | DefaultBfoVariantEnum | null,
  formatter: IFormatter
): IVerRowWithPeriod[] => {
  let rowIndex = 0;
  const newBfoRows = verRows.reduce<IVerRowWithPeriod[]>((prevVerRows, row: IVerRow) => {
    const debet =
      formatter.parser.parse(row.Debet ?? '').value === 0
        ? null
        : row.Debet ?? null;

    const kredit =
      formatter.parser.parse(row.Kredit ?? '').value === 0
        ? null
        : row.Kredit ?? null;

    const verRowsArray = [];

    const switchDebetAndKredit =
      bokforderType === TEDEKBokforderVariantEnum.VAND ||
      bokforderType === TEDEKBokforderVariantEnum.OMBOKFOR ||
      bokforderType === TEDEKBokforderVariantEnum.PERIODISERA;

    const verRow: IVerRowWithPeriod = {
      ...row,
      id: `${NEWLY_ADDED_ID_PREFIX_FOR_UPDATE}Bokforder_Rad_${rowIndex}`,
      Debet: switchDebetAndKredit ? kredit : debet,
      Kredit: switchDebetAndKredit ? debet : kredit,
      Text: row.Text,
      refLopnr:
        bokforderType === TEDEKBokforderVariantEnum.KOPIERA
          ? null
          : row.refLopnr,
      periodFrom: undefined,
      periodTo: undefined,
    };

    verRowsArray.push(verRow);
    rowIndex++;

    if (
      bokforderType === TEDEKBokforderVariantEnum.OMBOKFOR ||
      bokforderType === TEDEKBokforderVariantEnum.PERIODISERA
    ) {
      const emptyRow: IVerRowWithPeriod = {
        ...row,
        id: `${NEWLY_ADDED_ID_PREFIX_FOR_UPDATE}Bokforder_Rad_${rowIndex}`,
        _Associations:
          bokforderType === TEDEKBokforderVariantEnum.PERIODISERA
            ? row._Associations
            : null,
        Debet: debet,
        Kredit: kredit,
        Text: '',
        refLopnr: null,
        periodFrom: row.periodFrom,
        periodTo: row.periodTo,
      };

      verRowsArray.push(emptyRow);
      rowIndex++;
    }

    return [...prevVerRows, ...verRowsArray];
  }, []);

  return newBfoRows;
};

export const getTitlePrefix = (
  action: TEDEKBokforderVariantEnum | DefaultBfoVariantEnum | null
) => {
  switch (action) {
    case TEDEKBokforderVariantEnum.KOPIERA:
      return 'Kopia';

    case TEDEKBokforderVariantEnum.OMBOKFOR:
      return 'Omföring';

    case TEDEKBokforderVariantEnum.PERIODISERA:
      return 'Periodisering';

    case TEDEKBokforderVariantEnum.VAND:
      return 'Vändning';

    default:
      return '';
  }
};

export const makeTillgodourval: () => IUIUrval = () => {
  const tillgodoUrval: TEDInputSelectionCondition[][] = [
    [
      {
        namn: 'Tillgodohavande',
        ass: [],
        typ: TEDSelectionConditionType.Value,
        valueCondition: {
          op: TEDSelectionOperator.greater,
          value: [
            {
              value: '0',
            },
          ],
        },
      },
      {
        ass: ['KundKategori'],
        namn: 'TYP',
        typ: TEDSelectionConditionType.Enum,
        enumCondition: {
          selected: [TEDKRKundkategoriTypEnum.FAKTURAKUNDKATEGORI],
        },
      },
      {
        ass: ['KundKategori'],
        namn: 'INTERN',
        typ: TEDSelectionConditionType.Enum,
        enumCondition: { selected: [TEDKRKundkategoriINTERNEnum.EXTERN] },
      },
      {
        namn: 'HarAktivUtanordning',
        typ: TEDSelectionConditionType.Boolean,
        booleanCondition: { no: true },
      },
    ],
  ];

  return convertTEDUrvalToUIUrval(
    'KRKund',
    tillgodoUrval,
    collectionMap
  ).unsafelyUnwrap();
};

export const makeVerificationUrval = (bokfAr: string, verNr: string) =>
  convertTEDUrvalToUIUrval(
    'EKBokfver',
    [
      [
        {
          namn: 'BACKAD',
          ass: [],
          typ: TEDSelectionConditionType.Boolean,
          booleanCondition: { no: true },
        },
        {
          namn: 'I_HUVUDBOK',
          ass: [],
          typ: TEDSelectionConditionType.Boolean,
          booleanCondition: { yes: true },
        },
        {
          namn: 'BOKF_AR',
          ass: [],
          typ: TEDSelectionConditionType.Value,
          valueCondition: {
            op: TEDSelectionOperator.equals,
            value: [
              {
                value: new Date(bokfAr).toLocaleDateString('sv-SE'),
                tovalue: '',
              },
            ],
          },
        },
        {
          namn: 'StringVernr',
          ass: [],
          typ: TEDSelectionConditionType.Value,
          valueCondition: {
            op: TEDSelectionOperator.contains,
            value: [
              {
                value: verNr,
                tovalue: '',
              },
            ],
          },
        },
        {
          namn: 'VERKAT_KOD',
          ass: [],
          typ: TEDSelectionConditionType.Enum,
          enumCondition: {
            selected: [
              TEDEKBokfverVERKAT_KODEnum.EK_VERIFIKATIONSREGISTRERING,
              TEDEKBokfverVERKAT_KODEnum.LR_DEFINITIVBOKNING,
              TEDEKBokfverVERKAT_KODEnum.BJ_FAKTURERA_BISATTNINGAR,
              TEDEKBokfverVERKAT_KODEnum.EK_BOKFORINGSFIL_FRAN_KOB,
              TEDEKBokfverVERKAT_KODEnum.WEK_BOKFORINGSORDER,
              TEDEKBokfverVERKAT_KODEnum.EK_IMPORT_ENLIGT_SIE,
            ],
          },
        },
      ],
    ],
    collectionMap
  ).unsafelyUnwrap();

export const getCreateDialogFooterActionLabel = (
  mode: TEDEKBokforderVariantEnum
): string => {
  let result = '';
  switch (mode) {
    case TEDEKBokforderVariantEnum.MALL:
      result = 'Använd mall';
      break;
    case TEDEKBokforderVariantEnum.TOM:
      result = 'Använd';
      break;

    default:
      result = 'Använd';
      break;
  }
  return result;
};

export const convertKonteringsRowsToVerRow = (
  konteringRows: BokforderVerificationQuery_node_TEDEKBokfver__Associations_Konteringar_All[],
  currFormatter: IFormatter
): IVerRow[] => {
  const verRow: IVerRow[] =
    konteringRows.map(kontering => {
      return {
        id: kontering.id,
        Kontostrang: kontering.Kontostrang,
        Kontoben: kontering.Kontoben,
        Kredit:
          kontering.KREDIT === 0
            ? null
            : currFormatter.displayer.display(
                kontering.KREDIT,
                true,
                'DisplayZeroAsBlank="Y"'
              ),
        Debet:
          kontering.DEBET === 0
            ? null
            : currFormatter.displayer.display(
                kontering.DEBET,
                true,
                'DisplayZeroAsBlank="Y"'
              ),
        Periodiserad: kontering.PERIODISERAD ? YesOrNoEnum.Yes : YesOrNoEnum.No,
        PeriodFrom: null,
        PeriodTom: null,
        Automatkonterat:
          kontering.AUTOMAT_ID != null ? YesOrNoEnum.Yes : YesOrNoEnum.No,
        Text: kontering.TEXT,
        refLopnr: kontering.LOPNR,
        _Associations: {
          ...kontering._Associations,
        } as BokforderVerificationQuery_node_TEDEKBokfver__Associations_Konteringar_All__Associations,
      };
    }) ?? [];
  return verRow;
};

export const getOmbokningstypFormUpdateValue = (
  variant: TEDEKBokforderVariantEnum
): FormUpdateAssociatonType[] => {
  const ombokningstyp = translateBokforderTypeToOmforingsType(variant);

  const newValues: FormUpdateAssociatonType[] = [
    {
      operation: 'OwnFields',
      values: {
        OMFORINGSTYP: ombokningstyp,
      },
    },
  ];

  return newValues;
};

export const copyRows = (
  makeNewRow: (
    id: string,
    newValues?: IValues | undefined
  ) => FormUpdateAssociatonType[],
  rows:
    | BokforderQuery_node_TEDEKBokforder__Associations_Rader[]
    | UtanordningQuery_node_TEDEKBokforder__Associations_Rader[]
): FormUpdateAssociatonType[][] => {
  const newValues: FormUpdateAssociatonType[][] = [];

  rows?.forEach((row, index) => {
    const rowID = `${NEWLY_ADDED_ID_PREFIX_FOR_UPDATE}Bokforder_Rad_${index}`;
    const newRow = makeNewRow(rowID, {
      DEBET: row.DEBET,
      KREDIT: row.KREDIT,
      MALLRAD_LOPNR: row.MALLRAD_LOPNR,
      LIKVIDSATT: row.LIKVIDSATT,
      TEXT: row.TEXT,
    });

    newValues.push(newRow);

    for (const [key, value] of Object.entries(row?._Associations ?? {})) {
      if (key.includes('Kontodel') || key.includes('Attestant')) {
        const valueID = value?.id ?? null;

        if (valueID) {
          newValues.push([
            {
              associationName: 'Rader',
              operation: 'Add_Values',
              id: rowID,
            },
            {
              associationName: `${key}`,
              operation: 'Ref',
              id: valueID,
              values: { id: valueID },
            },
          ]);
        }
      }
    }
  });

  return newValues;
};

export const getFormUpdateWithKundInformation = (
  valdTillgodoKund: ISelectedKundRow
): FormUpdateAssociatonType[][] => {
  const updateArray: FormUpdateAssociatonType[][] = [
    [
      {
        operation: 'OwnFields',
        values: {
          TEXT: `Utbetalning av tillgodohavande - Kundnr;${valdTillgodoKund.KUNDNR_KONTONR}`,
          U_BETALNINGSMOTTAGARE: valdTillgodoKund.Namn,
          U_BELOPP: valdTillgodoKund.Tillgodohavande,
        },
      },
    ],
  ];

  return updateArray;
};
